/**
 * AuditFunnelChart — horizontal funnel / bar chart for AE deal pipeline.
 *
 * Shows how many deals sit at each CP stage.
 * For Today window: funnel view.
 * For longer windows: same component renders as horizontal bars.
 */
import { tokens } from "@/components/operator/tokens";
import { AE_FUNNEL_DATA } from "./audit-mock-data";

interface Props {
  data?: typeof AE_FUNNEL_DATA;
}

export default function AuditFunnelChart({ data = AE_FUNNEL_DATA }: Props) {
  const max = Math.max(...data.map((d) => d.count), 1);

  return (
    <div style={{ width: "100%" }}>
      <div style={{ fontSize: 13, fontWeight: 600, color: tokens.color.textPrimary, marginBottom: 12 }}>
        Pipeline by Checkpoint Stage
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
        {data.map((d) => {
          const pct = (d.count / max) * 100;
          return (
            <div key={d.stage} style={{ display: "flex", alignItems: "center", gap: 10 }}>
              {/* Stage label */}
              <div
                style={{
                  width: 120,
                  fontSize: 11,
                  fontWeight: 600,
                  color: tokens.color.textMuted,
                  letterSpacing: "0.03em",
                  flexShrink: 0,
                  textAlign: "right",
                }}
              >
                {d.label}
              </div>

              {/* Bar track */}
              <div
                style={{
                  flex: 1,
                  height: 24,
                  background: "#EFEFEE",
                  borderRadius: 4,
                  overflow: "hidden",
                  position: "relative",
                }}
              >
                <div
                  style={{
                    width: `${pct}%`,
                    height: "100%",
                    background: d.stage === "Won" ? tokens.color.success : tokens.color.black,
                    borderRadius: 4,
                    transition: "width 0.3s",
                    display: "flex",
                    alignItems: "center",
                    paddingLeft: 8,
                  }}
                />
              </div>

              {/* Count */}
              <div
                style={{
                  width: 24,
                  fontSize: 12,
                  fontWeight: 700,
                  color: tokens.color.textPrimary,
                  textAlign: "right",
                  flexShrink: 0,
                }}
              >
                {d.count}
              </div>
            </div>
          );
        })}
      </div>

      <div style={{ fontSize: 11, color: tokens.color.textSubtle, marginTop: 12 }}>
        Deals in active pipeline by current checkpoint
      </div>
    </div>
  );
}
